// Portuguese Postcode
const ptPostcode = (value) => {
  const pattern = /^\d{4}-\d{3}$/;
  
  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', '0000-000'];
  }
};

export default ptPostcode;
